import type { AxiosError } from 'axios';
import { getOrganizationBillAddressesSearch } from 'apis/organization_bill_addresses/search';
import { getOrganizationsSearch } from 'apis/organizations/search';

export const checkRegistrationBillAddressRequired =
  async (): Promise<boolean> => {
    let required: boolean = false;

    try {
      const res = await getOrganizationsSearch();
      if (res.status === 200 && res.data && res.data.billAddressRequired) {
        await getOrganizationBillAddressesSearch().catch(
          (error: AxiosError) => {
            required = error.response?.status === 404;
          }
        );
      }
    } catch (error) {
      return false; // fail safe
    }

    return required;
  };
